var demoVideos = [
{
  videoId: "iPad.mp4",
  coverImg: require('../assets/iPad_picture.jpg'),
  title: "iPad 解壓縮方法"
},
{
  videoId: "iPhone.mp4",
  coverImg: require('../assets/iPhone_picture.jpg'),
  title: "iPhone 解壓縮方法"
},
{
  videoId: "AndroidPhone.mp4",
  coverImg: require('../assets/AndroidPhone.jpg'),
  title: "Android 解壓縮方法"
}

];
export default demoVideos
